import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';

export const thetaLevelsGetter = function (PineJS) {
  return Promise.resolve([
    {
      name: 'SPX Charm Levels',
      metainfo: {
        metainfoVersion: 53,
        id: "SPX Charm Levels@tv-basicstudies-1",
        description: "SPX Charm Levels",
        shortDescription: "SPX Charm Levels",
        format: { type: "price" },
        linkedToSeries: true,
        is_price_study: true,
        plots: [
          { id: "call_r1", type: "line" },
          { id: "call_r2", type: "line" },
          { id: "put_r1",  type: "line" },
          { id: "put_r2",  type: "line" }
        ],
        defaults: {
          styles: {
            call_r1: {
              linestyle: 0,
              linewidth: 1,
              transparency: 0,
              color: "#00FFFF",
            },
            call_r2: {
              linestyle: 1,
              linewidth: 1,
              transparency: 0,
              color: "#00FFFF",
            },
            put_r1: {
              linestyle: 0,
              linewidth: 1,
              transparency: 0,
              color: "#FF00FF",
            },
            put_r2: {
              linestyle: 1,
              linewidth: 1,
              transparency: 0,
              color: "#FF00FF",
            },
          },
        },
        styles: {
          call_r1: { title: "Charm Call R1" },
          call_r2: { title: "Charm Call R2" },
          put_r1:  { title: "Charm Put R1" },
          put_r2:  { title: "Charm Put R2" },
        },
        inputs: [],
      },
      constructor: function () {
        this._debugMode = true;

        this.init = function (ctx) {
          this._context = ctx;
        };

        this.main = function (ctx) {
          try {
            const { topOptions } = useGreeksWebsocketDataStore.getState();
            const spxOptions = topOptions.spx;

            if (!spxOptions?.length) {
              if (this._debugMode) {
                // console.log('[thetaLevelsGetter] No top options data');
              }
              return [NaN, NaN, NaN, NaN];
            }

            // Filter for Theta-based options
            const thetaOptions = spxOptions.filter(opt => opt.greek_type === 'theta');

            const callR1 = thetaOptions.find(opt => opt.option_type === 'call' && opt.rank === 1)?.strike_price || NaN;
            const callR2 = thetaOptions.find(opt => opt.option_type === 'call' && opt.rank === 2)?.strike_price || NaN;
            const putR1 = thetaOptions.find(opt => opt.option_type === 'put' && opt.rank === 1)?.strike_price || NaN;
            const putR2 = thetaOptions.find(opt => opt.option_type === 'put' && opt.rank === 2)?.strike_price || NaN;

            // if (this._debugMode) {
            //   console.log('[thetaLevelsGetter] Levels:', {
            //     callR1,
            //     callR2,
            //     putR1,
            //     putR2,
            //     optionsCount: thetaOptions.length
            //   });
            // }

            return [callR1, callR2, putR1, putR2];
          } catch (err) {
            console.error('[thetaLevelsGetter] Error in main:', err);
            return [NaN, NaN, NaN, NaN];
          }
        };

        this.destroy = function() {
          // No cleanup needed since we're not using subscriptions
        };
      },
    },
  ]);
};

